import { render, staticRenderFns } from "./feedbackTrainer.vue?vue&type=template&id=5cf508d9&scoped=true"
import script from "./feedbackTrainer.vue?vue&type=script&lang=js"
export * from "./feedbackTrainer.vue?vue&type=script&lang=js"
import style0 from "./feedbackTrainer.vue?vue&type=style&index=0&id=5cf508d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf508d9",
  null
  
)

export default component.exports